import { render, staticRenderFns } from "./LevButton.vue?vue&type=template&id=46215bfa"
import script from "./LevButton.vue?vue&type=script&lang=js"
export * from "./LevButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports